import { registerLocaleData } from '@angular/common';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { LocaleId, NgLocale } from '@trimble-gcs/i18n-types';

export const LOCALES_PATH = new InjectionToken<string>('LOCALES_PATH');

@Injectable({
  providedIn: 'root',
})
export class LocaleLoader {
  private localesPath = inject(LOCALES_PATH);
  private localeCache = new Map<LocaleId, unknown>();

  async loadLocale(ngLocale: NgLocale, localeId: LocaleId): Promise<void> {
    if (this.localeCache.has(localeId)) return;

    const { default: localeData } = await import(
      /* @vite-ignore */
      `${this.localesPath}/${ngLocale}.mjs`
    );

    const { default: localeExtra } = await import(
      /* @vite-ignore */
      `${this.localesPath}/extra/${ngLocale}.mjs`
    );

    registerLocaleData(localeData, localeId, localeExtra);
    this.localeCache.set(localeId, { localeData, localeExtra });
  }
}
